var serverIp = ''
export default  {
    serverIp:serverIp
}